import { Campaign, CampaignDonation, Maybe } from 'Generated/graphql-types'
import { colors } from 'Themes/Colors'

export const CAMPAIGN_GOAL_START_LABEL = 'Start'

export const sortCampaignsByDate = (campaigns: Campaign[]) =>
  campaigns
    .slice()
    .sort(
      (a, b) =>
        new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime()
    )

export const extractUniqueDonationDates = (campaignGoals: Campaign[]) =>
  Array.from(
    new Set(
      campaignGoals.flatMap(
        (campaign) =>
          campaign.donations?.map((d) => d?.createdAt?.split('T')[0]) || []
      )
    )
  ).sort()

export const assignColorsToCampaigns = (sortedCampaigns: Campaign[]) =>
  sortedCampaigns.reduce((acc, campaign, index) => {
    acc[campaign.name || ''] =
      colors[`dimension${index}` as keyof typeof colors]
    return acc
  }, {} as { [key: string]: string })

export const filterValidDonations = (donations: Maybe<CampaignDonation>[]) =>
  donations.filter(
    (donation): donation is CampaignDonation =>
      !!donation && !donation.disputed && !donation.refunded
  )

export const sortDonationsByDate = (donations: CampaignDonation[]) =>
  donations
    .slice()
    .sort(
      (a, b) =>
        new Date(a?.createdAt || '').getTime() -
        new Date(b?.createdAt || '').getTime()
    )

export const aggregateDonations = (donations: CampaignDonation[]) =>
  donations.reduce((acc, donation) => {
    if (donation && donation.createdAt && donation.netAmount) {
      const date = donation.createdAt.split('T')[0]
      acc[date] = (acc[date] || 0) + donation.netAmount
    }
    return acc
  }, {} as { [key: string]: number })

export const formatDate = (dateString: string) => {
  const [year, month, day] = dateString.split('-')
  const formattedDate = `${month}/${day}/${year}`
  return formattedDate
}

export const getEarliestDate = (dates: string[]) => {
  const minDateTime = dates.reduce((a, b) => (a < b ? a : b))
  const minDate = minDateTime?.split('T')[0]
  return minDate || null
}

export const formatCurrency = (amount: number) => {
  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: 2,
  })
  return formatter.format(amount)
}
